<template>
  <div class="footer-container">
    <div class="footer-inner">
      <p>
        <img src="../../assets/img/hu.png" alt="" class="hu-img">
        <span>
          <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502001670" target="_blank" class="hu-text">沪公网安备 31010502001670号</a>
        </span>
        <span> | </span>
        <span>沪ICP备10014315号-7 | Copyright: ©MICHELIN 2020</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  // padding-top: 20px;
  position: fixed;
  bottom: 0;
  z-index: 10;
}

.footer-inner {
  height: $footerHeight;
  font-size: 14px;
  line-height: $footerHeight;
  text-align: center;
  color: #fff;

  @include background_color_page_primary('color');
}

.hu-img {
  display: inline-block;
  margin-right: 4px;
  line-height: $footerHeight;
  vertical-align: sub;
}

.hu-text {
  font-size: 14px;
  color: #fff;

  &:hover {
    text-decoration: underline;
  }
}
</style>
